import { useState } from 'react';
import styles from './TrialCountdownBanner.module.scss';
import { useUserContext } from '../../contexts/UserContext';
import { ClockIcon } from '../../components/icons/ClockIcon';
import { TalkToSalesBookingModal } from '../TalkToSalesBooking/TalkToSalesBookingModal';

// Shows alongside the search bar wherever it's visible. During the backend's
// 1-day grace period, daysRemaining can be 0 while still not expired - keep
// showing "0 days left" rather than hiding early.
export default function TrialCountdownBanner() {
  const { freeTrialInfo } = useUserContext();
  const daysRemaining = freeTrialInfo?.freeTrialDaysRemaining;
  const [showTalkToSalesForm, setShowTalkToSalesForm] = useState(false);

  if (!freeTrialInfo?.isFreeTrialStarted || freeTrialInfo?.isFreeTrialExpired) return null;
  if (daysRemaining === null || daysRemaining === undefined) return null;

  return (
    <div className={`hiddenOnMobile ${styles.trialBanner}`}>
      <ClockIcon className={styles.clockIcon} />
      <span>
        {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} left in your free trial
      </span>
      <button
        type="button"
        className={styles.ctaLink}
        onClick={() => setShowTalkToSalesForm(true)}>
        Unlock Full Access
      </button>
      <TalkToSalesBookingModal
        open={showTalkToSalesForm}
        onClose={() => setShowTalkToSalesForm(false)}
      />
    </div>
  );
}
